import { render, staticRenderFns } from "./OrticFilter.vue?vue&type=template&id=852ecc90&"
import script from "./OrticFilter.vue?vue&type=script&lang=js&"
export * from "./OrticFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports